export const isLocalhost = (): boolean =>
  window.location.hostname.startsWith('localhost');
